import { render } from "./AdditionalFields.vue?vue&type=template&id=16986647&scoped=true&ts=true"
import script from "./AdditionalFields.vue?vue&type=script&lang=ts"
export * from "./AdditionalFields.vue?vue&type=script&lang=ts"

import "./AdditionalFields.vue?vue&type=style&index=0&id=16986647&lang=scss&scoped=true"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16986647"]])

export default __exports__